import { render, staticRenderFns } from "./ViewTokenContent.vue?vue&type=template&id=05f133d4&scoped=true"
import script from "./ViewTokenContent.vue?vue&type=script&lang=js"
export * from "./ViewTokenContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f133d4",
  null
  
)

export default component.exports